export const additional_error_keys = [
  'daily_budget',
  'experiment_plan',
  'experiment_type',
];

export const GENERIC_ERROR_MESSAGE =
  'An error occurred. Please try again. If the error persists, contact support with this error code: ';
